<template>
  <v-container>
    <div ref="chart" :style="{ height: height || '450px', width: '100%' }"></div>      
  </v-container>
</template>

<script>
import * as echarts from 'echarts';

export default {
  props: {
    options: {
      type: Object,
      required: true
    },
    height: {
      type: String,
      default: '450px',
    },
  },

  mounted() {
    this.waitForSize().then(() => {
    this.initChart();
    // Observa cambios de tamaño del contenedor
    this.ro = new ResizeObserver(() => this.chart?.resize());
    this.ro.observe(this.$refs.chart);
  });
  window.addEventListener('resize', this.handleResize);
},

beforeUnmount() {
  window.removeEventListener('resize', this.handleResize);
  this.ro?.disconnect();
  this.chart?.dispose();
},

  
  watch: {
  options: {
    deep: true,
    handler(newOptions) {
      this.updateChart(newOptions);
         
    }
  }
},
methods: {
  async waitForSize(timeout = 3000, step = 50) {
    const t0 = performance.now();
    const el = this.$refs.chart;
    while (performance.now() - t0 < timeout) {
      const w = el?.clientWidth || 0;
      const h = el?.clientHeight || 0;
      if (w > 0 && h > 0) return true;
      await new Promise(r => setTimeout(r, step));
    }
    return true; // seguimos, pero al menos el RO hará resize luego
  },

  initChart() {
    if (this.chart) return;
    try {
      this.chart = echarts.init(this.$refs.chart, null, { renderer: 'canvas', useDirtyRect: true });
      this.chart.on('rendered', () => this.$emit('rendered'));
      this.chart.on('finished', () => this.$emit('rendered'));
      this.chart.setOption(this.options || {}, { notMerge: true, lazyUpdate: false });
      this.chart.resize();
    } catch (e) { console.error('Error inicializando gráfico:', e); this.$emit('error', e); }
  },

  async updateChart(newOptions) {
    if (!this.chart) { this.initChart(); return; }
    try {
      this.chart.setOption(newOptions || {}, { notMerge: true, lazyUpdate: false });
      await this.$nextTick();
      this.chart.resize();
    } catch (e) { console.error('Error actualizando gráfico:', e); this.$emit('error', e); }
  },

  handleResize() { this.chart?.resize(); }
}
}
</script>
